import React from 'react'

import Modal from './modal'
import Button from './button'
import IconWarningTriangle from './icons/icon-warning-triangle'
import colors from '../../../css/colors'

type Props = {
  isOpen: boolean
  title: React.ReactNode
  description: React.ReactNode
  handleClose: () => void
}

const MODAL_WIDTH = 500
const ICON_SIZE = 24

function ErrorModal ({ isOpen, title, description, handleClose }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick
      width={MODAL_WIDTH}
      contentLabel='Error'
    >
      <div className='flex items-center mb2'>
        <IconWarningTriangle size={ICON_SIZE} color={colors.error} />
        <h2 className='mt0 mb0 ml2'>{title}</h2>
      </div>
      <p className='mt1 mb3'>{description}</p>
      <div className='flex justify-end'>
        <Button btnType='primary' className='ml2' onClick={handleClose}>OK</Button>
      </div>
    </Modal>
  )
}

export default ErrorModal
